"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, HostBinding, Input } from '@angular/core';
var ContainerComponent = (function () {
    function ContainerComponent() {
    }
    __decorate([
        HostBinding('attr.size'),
        Input(),
        __metadata("design:type", String)
    ], ContainerComponent.prototype, "container", void 0);
    ContainerComponent = __decorate([
        Component({
            selector: 'fl-container',
            template: "\n    <ng-content></ng-content>\n  ",
            styleUrls: ['./container.component.scss'],
        })
    ], ContainerComponent);
    return ContainerComponent;
}());
export { ContainerComponent };



// WEBPACK FOOTER //
// container.component.js